import axios from 'axios';

import { WosIsiReportParams, WosIsiReportType } from '@/module/WosIsiReport/model/WosIsiReportTypes';

export function generateWosIsiReport(type: WosIsiReportType, params: WosIsiReportParams) {
  const {
    startYear,
    endYear,
    startMonth,
    endMonth,
    wosType,
    indexingType,
    facultyId,
    departmentId,
    disciplineId,
    userId,
    validationStatus,
    filterAfterAffiliation,
  } = params;

  // luna se aplică doar pentru anul publicării, indexarea WoS nu are granularitate sub an
  const isMonthApplicable = indexingType === 'PUBLISHING_YEAR';

  return axios.get<Blob>(`/annual-report/generate/wos/${type}`, {
    responseType: 'blob',
    params: {
      startYear,
      endYear,
      startMonth: isMonthApplicable ? startMonth : null,
      endMonth: isMonthApplicable ? endMonth : null,
      wosType,
      indexingType,
      facultyId,
      departmentId,
      disciplineId,
      userId,
      validationStatus,
      filterAfterAffiliation,
    },
  });
}
